const HOME = '/'
const ABOUT = '/'
const USER = '/user'
const STORE = '/store'
const AUTH = '/auth'
const TEST = '/test'
const PAY = '/pay'
const SIGN_IN = '/sign_in'
const GAME = '/game'
const DEV = '/dev'
const FEEDBACK='/feedback'

export {
    HOME,
    ABOUT,
    USER,
    STORE,
    AUTH,
    TEST,
    PAY,
    SIGN_IN,
    GAME,
    DEV,
    FEEDBACK
}